<template>
  <div class="grid grid-cols-12 gap-x-4 gap-y-1 p-4 items-end">
    <div class="col-span-9 text-right">Total Net Amount</div>
    <div class="col-span-2 text-right">{{ totalNetAmount }} &euro;</div>
    <div class="col-span-9 text-right">Total Vat Amount</div>
    <div class="col-span-2 text-right">{{ totalVatAmount }} &euro;</div>
    <div class="col-span-9 text-right font-bold">Total</div>
    <div class="col-span-2 text-right font-bold">{{ totalAmount }} &euro;</div>
  </div>
</template>

<script>
export default {
  props: {
    lineItems: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    totalNetAmount() {
      return this.lineItems.reduce((sum, { quantity, pricePerUnit }) => {
        const lineNetAmount = Number.parseFloat(quantity * pricePerUnit);
        return Number.parseFloat(Number.parseFloat(sum + lineNetAmount).toFixed(2));
      }, 0);
    },
    totalVatAmount() {
      return this.lineItems.reduce((sum, { quantity, pricePerUnit, vatRate }) => {
        const lineNetAmount = Number.parseFloat(quantity * pricePerUnit);
        const lineVatAmount = Number.parseFloat(lineNetAmount * vatRate);
        return Number.parseFloat(Number.parseFloat(sum + lineVatAmount).toFixed(2));
      }, 0);
    },
    totalAmount() {
      return Number.parseFloat(
        Number.parseFloat(this.totalNetAmount + this.totalVatAmount).toFixed(2)
      );
    },
  },
};
</script>
